import React, { useEffect, useState } from 'react'
import styled from "styled-components"

const Loading = styled.div`
  margin: 180px auto;
  display: block;
  width: 80px;
  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #ddd;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
`

export default props => {
  let [show, setShow] = useState()

  useEffect(() => {
    setTimeout(function(){ setShow(true) }, 1000);
  })

  return (
    <Loading>
      {show && (
        <div className="lds-ripple">
          <div />
          <div />
        </div>
      )}
    </Loading>
  )
}
